import React, { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';

const CountdownTimer = () => {
  const targetDate = new Date('2026-02-28T00:00:00').getTime();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatNumber = (num) => num.toString().padStart(2, '0');

  return (
    <div className="hidden md:flex items-center gap-3 px-5 py-2.5 rounded-xl bg-gradient-to-r from-red-900/90 to-red-800/90 border border-yellow-500/40 backdrop-blur-md shadow-[0_4px_10px_rgba(220,38,38,0.3)] hover:shadow-[0_4px_15px_rgba(253,224,71,0.2)] transition-all duration-300 group relative overflow-hidden">
      {/* Glossy overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent pointer-events-none"></div>
      
      <div className="p-1.5 rounded-lg bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 shadow-inner">
        <Timer size={18} className="animate-pulse" />
      </div>
      
      <div className="flex items-center gap-2 text-sm font-medium z-10">
        <div className="flex flex-col items-center">
          <span className="font-bold font-serif text-yellow-100 text-lg leading-tight drops-shadow-sm">
            {timeLeft.days}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-yellow-500/80 font-bold scale-90">
            Ngày
          </span>
        </div>
        <span className="text-yellow-600/50 pb-3 text-xl font-serif">:</span>
        
        <div className="flex flex-col items-center">
          <span className="font-bold font-serif text-white text-lg leading-tight">
            {formatNumber(timeLeft.hours)}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-yellow-500/80 font-bold scale-90">
            Giờ
          </span>
        </div>
        <span className="text-yellow-600/50 pb-3 text-xl font-serif">:</span>
        
        <div className="flex flex-col items-center">
          <span className="font-bold font-serif text-white text-lg leading-tight">
            {formatNumber(timeLeft.minutes)}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-yellow-500/80 font-bold scale-90">
            Phút
          </span>
        </div>
        <span className="text-yellow-600/50 pb-3 text-xl font-serif">:</span>
        
        <div className="flex flex-col items-center min-w-[20px]">
          <span className="font-bold font-serif text-yellow-300 text-lg leading-tight">
            {formatNumber(timeLeft.seconds)}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-yellow-500/80 font-bold scale-90">
            Giây
          </span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
